import axios from 'axios';
import { endpoints } from '@/api/endpoints.js';
import { baseURL } from '../../../api/environment';

const URL = baseURL;

/**
 * Envía un SMS de validación al teléfono del usuario
 */
export const sendSMS = async ({ commit, rootState }, params) => {
    try {
        commit('SET_LOADING', true);
        const endpoint = endpoints.checkout.sendSMS.endpoint;
        const token = await rootState.Token.token.dataObj;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                telefono: params
            }
        });
        
        commit('SET_SMS', data);
    } catch (err) {
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Valida el código SMS ingresado por el usuario
 */
export const sendValidateSMS = async ({ commit, rootState }, params) => {
    try {
        commit('SET_LOADING', true);
        const endpoint = endpoints.checkout.validateSMS.endpoint;
        const token = rootState.Token.token.dataObj;
        const telefono = await rootState.Users.user_contact.telefono;
        const codigo = params.code;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                telefono: telefono,
                codigo: codigo
            }
        });

        if (data.res) {
            if (data.dataObj.validacion.toUpperCase() == "FALSE") {
                commit('SET_ERROR_SUBSCRIPTION', data.msg);
                commit('SET_SMS_VALIDATION', null);
            } else {
                commit('SET_SMS_VALIDATION', data.res);
            }
        } else {
            commit('SET_SMS_VALIDATION', data.res);
        }
    } catch (err) {
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};
